// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56537":"6a8358eb","73442":"6a8358eb"}[chunkId] + ".chunk.css";
};